import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { TooltipTextProvider } from '@elliemae/ds-basic/TruncatedTooltipText';
import DataGridImpl from './DataGridImpl.js';
import { RowSizesOptionsArr, RowSizesOptions } from './rowSizes.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@elliemae/ds-shared/utils';
import '@elliemae/ds-shared/useDataGrid';
import './components/Table.js';
import './components/TableHeader.js';
import './components/tableContext.js';
import './components/TableBody.js';
import './components/HeaderCell.js';
import 'prop-types';
import '@elliemae/ds-shared/createDataInstance/utils';
import './components/BodyCell.js';
import '@elliemae/ds-shared/FocusGroup/FocusGrid';
import './index-4a6329dc.js';
import './components/renderers/defaultClassedRenderers.js';
import '@elliemae/ds-classnames';
import './blockNames.js';
import './components/renderers/renderRowsLoader.js';
import './components/RowsLoader.js';
import '@elliemae/ds-basic/Spinner';
import './components/footer/addOptionalFooterComponents.js';
import './plugins/pagination/components/Pagination.js';
import './plugins/pagination/components/Paginator.js';
import 'react-pagify';
import 'segmentize';
import './plugins/pagination/components/PerPageDropdown.js';
import 'memoize-one';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-basic/form/ComboBox';
import './components/header/addOptionalHeaderComponents.js';
import '@elliemae/ds-filterbar';
import './components/EmptyState.js';
import '@elliemae/ds-basic/Grid';
import '@elliemae/ds-icons/WarningTriangle';
import '@elliemae/ds-system';
import '@elliemae/ds-basic/Button';
import 'styled-components';
import './utilities/getPluginsFromProps.js';
import './plugins/row-dnd/DndRowsPlugin.js';
import 'react-sortable-hoc';
import '@elliemae/ds-icons/GripperVertical';
import '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import './plugins/column-dnd/DndColumnsPlugin.js';
import '@elliemae/ds-utilities/system';
import './plugins/column-dnd/decorateGridWithDndColumns.js';
import './plugins/infinite-scrolling/InfiniteScrollPlugin.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/asyncToGenerator';
import '@babel/runtime/regenerator';
import './plugins/editable/EditablePlugin.js';
import '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';
import './plugins/editable/decorateEditable.js';
import 'react-edit';
import '@elliemae/ds-icons/EditPencil';
import './plugins/editable/getEditorComponent.js';
import './plugins/editable/EditableComponents/ComboBox.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import './plugins/editable/EditableComponents/TextBox.js';
import '@elliemae/ds-basic/form/TextBox';
import './plugins/sortable/SortablePlugin.js';
import 'sortabular';
import './plugins/sortable/sortHeaderFormatter.js';
import '@elliemae/ds-icons/ArrowheadDown';
import '@elliemae/ds-icons/ArrowheadUp';
import './plugins/sortable/useSortableState.js';
import 'sortabular/dist';
import './plugins/sortable/checkIfSortable.js';
import './plugins/sortable/sorter.js';
import 'moment';
import './plugins/selectable/SelectablePlugin.js';
import 'obj-str';
import './plugins/selectable/addSelectableColumn.js';
import './plugins/selectable/selectableFormatter.js';
import '@elliemae/ds-basic/form/Checkbox';
import '@elliemae/ds-basic/form/Radio';
import './plugins/selectable/useSelectableState.js';
import './plugins/selectable/helper.js';
import './plugins/filterable/FilterablePlugin.js';
import './plugins/filterable/addFilterToColumn.js';
import './plugins/filterable/filterableFormatter.js';
import './plugins/filterable/components/FilterableHeader.js';
import '@elliemae/ds-utilities/hooks/useResizeObserver';
import '@elliemae/ds-system/theme';
import './plugins/filterable/components/filterable-menus/getFilterMenuByType.js';
import './plugins/filterable/components/filterable-menus/DateRangeFilterMenu.js';
import '@elliemae/ds-date-range-picker';
import '@elliemae/ds-date-picker';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-icons/DatePicker2';
import './plugins/filterable/components/filterable-menus/defaultDateFormat.js';
import './plugins/filterable/components/filterable-menus/SingleDateFilterMenu.js';
import './plugins/filterable/components/filterable-menus/SingleRangeSwitcherMenu.js';
import './plugins/filterable/components/filterable-menus/TextFilterMenu.js';
import 'lodash';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-menu';
import '@elliemae/ds-icons/SearchSmall';
import './plugins/filterable/helper.js';
import './plugins/filterable/filtering-helper/filterRowsByQuery.js';
import './plugins/filterable/filtering-helper/strategiesOperators.js';
import 'comparejs';
import './plugins/filterable/useFilterableState.js';
import 'uuid';
import './plugins/toolbar/ToolbarPlugin.js';
import './plugins/toolbar/RowRenderer.js';
import './plugins/toolbar/ToolbarTrigger.js';
import '@elliemae/ds-icons/MoreOptionsVert';
import './plugins/pagination/PaginationPlugin.js';
import './plugins/pagination/helper.js';
import './plugins/pagination/usePaginationState.js';
import './components/NoResults.js';
import './plugins/virtualization/VirtualizationPlugin.js';
import './plugins/virtualization/VirtualizedBody.js';
import './plugins/virtualization/VirtualizedBodyRow.js';
import './plugins/virtualization/helper.js';
import './plugins/expandable-grid/ExpandablePlugin.js';
import 'react-window';
import '@elliemae/ds-icons/ArrowheadRight';
import './plugins/expandable-grid/ExpandedRow.js';
import '@elliemae/ds-basic/Separator';
import '@elliemae/ds-shared/defer-render-hoc';
import './plugins/column-sizing/ColumnSizingPlugin.js';
import './plugins/column-sizing/useStylesheetHelpers.js';
import 'stylesheet-helpers';
import './plugins/column-sizing/getColumnNameFromProperty.js';
import './utilities/getScrollbarSize.js';
import './plugins/column-sizing/useColumnSizeService.js';
import './plugins/column-sizing/utils.js';
import './plugins/column-sizing/ext-points/getTableProps.js';
import './plugins/column-sizing/ext-points/decorateColumn.js';
import './plugins/column-sizing/columnMeasurerTransformer.js';
import './plugins/expandable-grid/ExpandedRowExtra.js';
import './plugins/expandable-grid/useExpandGridState.js';
import '@elliemae/ds-utilities/hooks/useExpandState';
import './plugins/grouping-grid/GroupingPlugin.js';
import './plugins/grouping-grid/walkStrategy.js';
import './plugins/grouping-by/GroupingByPlugin.js';
import './defaultPlugins.js';
import './plugins/body-header-scroll-sync/BodyHeaderScrollSyncPlugin.js';
import '@elliemae/ds-shared/ScrollSync';
import './plugins/resizable/ResizablePlugin.js';
import './plugins/resizable/decorateResizable.js';
import './plugins/resizable/useResizeHandle.js';
import './plugins/custom-cell-renderer/CustomRendererPlugin.js';
import './plugins/custom-cell-renderer/addCustomRendererToCell.js';
import './plugins/custom-cell-renderer/getRendererComponent.js';
import '@elliemae/ds-basic/form/Toggle';
import './utilities/normalizeData.js';

/* eslint-disable max-lines */

var DSDataGrids = function DSDataGrids(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      instanceRef = _ref.instanceRef,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? [] : _ref$rows,
      _ref$rowKey = _ref.rowKey,
      rowKey = _ref$rowKey === void 0 ? 'id' : _ref$rowKey,
      _ref$infiniteScrollin = _ref.infiniteScrolling,
      infiniteScrolling = _ref$infiniteScrollin === void 0 ? false : _ref$infiniteScrollin,
      _ref$editable = _ref.editable,
      editable = _ref$editable === void 0 ? false : _ref$editable,
      _ref$sortable = _ref.sortable,
      sortable = _ref$sortable === void 0 ? false : _ref$sortable,
      _ref$sortEmptyLast = _ref.sortEmptyLast,
      sortEmptyLast = _ref$sortEmptyLast === void 0 ? false : _ref$sortEmptyLast,
      _ref$paginated = _ref.paginated,
      paginated = _ref$paginated === void 0 ? false : _ref$paginated,
      _ref$dragAndDropRows = _ref.dragAndDropRows,
      dragAndDropRows = _ref$dragAndDropRows === void 0 ? false : _ref$dragAndDropRows,
      _ref$selectable = _ref.selectable,
      selectable = _ref$selectable === void 0 ? false : _ref$selectable,
      _ref$resizeableColumn = _ref.resizeableColumns,
      resizeableColumns = _ref$resizeableColumn === void 0 ? false : _ref$resizeableColumn,
      _ref$searchFilters = _ref.searchFilters,
      searchFilters = _ref$searchFilters === void 0 ? false : _ref$searchFilters,
      _ref$dragAndDropColum = _ref.dragAndDropColumns,
      dragAndDropColumns = _ref$dragAndDropColum === void 0 ? false : _ref$dragAndDropColum,
      _ref$useTreeData = _ref.useTreeData,
      useTreeData = _ref$useTreeData === void 0 ? false : _ref$useTreeData,
      autoScrollToId = _ref.autoScrollToId,
      _ref$overscanCount = _ref.overscanCount,
      overscanCount = _ref$overscanCount === void 0 ? 10 : _ref$overscanCount,
      _ref$selectAll = _ref.selectAll,
      selectAll = _ref$selectAll === void 0 ? false : _ref$selectAll,
      _ref$selectedRows = _ref.selectedRows,
      selectedRows = _ref$selectedRows === void 0 ? [] : _ref$selectedRows,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? undefined : _ref$filters,
      _ref$onAddFilter = _ref.onAddFilter,
      onAddFilter = _ref$onAddFilter === void 0 ? function () {
    return null;
  } : _ref$onAddFilter,
      _ref$onRemoveFilter = _ref.onRemoveFilter,
      onRemoveFilter = _ref$onRemoveFilter === void 0 ? function () {
    return null;
  } : _ref$onRemoveFilter,
      _ref$onFiltersChange = _ref.onFiltersChange,
      onFiltersChange = _ref$onFiltersChange === void 0 ? function () {
    return null;
  } : _ref$onFiltersChange,
      _ref$showFilterBar = _ref.showFilterBar,
      showFilterBar = _ref$showFilterBar === void 0 ? true : _ref$showFilterBar,
      _ref$multiSelectFilte = _ref.multiSelectFilterOptions,
      multiSelectFilterOptions = _ref$multiSelectFilte === void 0 ? [{
    id: 'true',
    label: 'Selected'
  }, {
    id: 'false',
    label: 'Not selected'
  }] : _ref$multiSelectFilte,
      _ref$multiSelectFilte2 = _ref.multiSelectFilterLabels,
      multiSelectFilterLabels = _ref$multiSelectFilte2 === void 0 ? undefined : _ref$multiSelectFilte2,
      _ref$multiSelectFilte3 = _ref.multiSelectFilterLabel,
      multiSelectFilterLabel = _ref$multiSelectFilte3 === void 0 ? 'Selection' : _ref$multiSelectFilte3,
      _ref$aggregations = _ref.aggregations,
      aggregations = _ref$aggregations === void 0 ? {} : _ref$aggregations,
      _ref$groupingColumn = _ref.groupingColumn,
      groupingColumn = _ref$groupingColumn === void 0 ? undefined : _ref$groupingColumn,
      _ref$sortingColumns = _ref.sortingColumns,
      sortingColumns = _ref$sortingColumns === void 0 ? {} : _ref$sortingColumns,
      _ref$minPerPage = _ref.minPerPage,
      minPerPage = _ref$minPerPage === void 0 ? 0 : _ref$minPerPage,
      _ref$maxPerPage = _ref.maxPerPage,
      maxPerPage = _ref$maxPerPage === void 0 ? 50 : _ref$maxPerPage,
      _ref$onPerPageChange = _ref.onPerPageChange,
      onPerPageChange = _ref$onPerPageChange === void 0 ? function () {
    return null;
  } : _ref$onPerPageChange,
      _ref$onPageChange = _ref.onPageChange,
      onPageChange = _ref$onPageChange === void 0 ? function () {
    return null;
  } : _ref$onPageChange,
      _ref$paginationStep = _ref.paginationStep,
      paginationStep = _ref$paginationStep === void 0 ? 2 : _ref$paginationStep,
      _ref$pagination = _ref.pagination,
      pagination = _ref$pagination === void 0 ? {
    page: 1,
    perPage: 10
  } : _ref$pagination,
      _ref$showHeader = _ref.showHeader,
      showHeader = _ref$showHeader === void 0 ? true : _ref$showHeader,
      _ref$fixedHeader = _ref.fixedHeader,
      fixedHeader = _ref$fixedHeader === void 0 ? true : _ref$fixedHeader,
      _ref$wrapText = _ref.wrapText,
      wrapText = _ref$wrapText === void 0 ? false : _ref$wrapText,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? undefined : _ref$height,
      _ref$minColumnWidth = _ref.minColumnWidth,
      minColumnWidth = _ref$minColumnWidth === void 0 ? 100 : _ref$minColumnWidth,
      _ref$showRowsLoader = _ref.showRowsLoader,
      showRowsLoader = _ref$showRowsLoader === void 0 ? false : _ref$showRowsLoader,
      _ref$visibleColumns = _ref.visibleColumns,
      visibleColumns = _ref$visibleColumns === void 0 ? undefined : _ref$visibleColumns,
      _ref$showSelectHighli = _ref.showSelectHighlight,
      showSelectHighlight = _ref$showSelectHighli === void 0 ? false : _ref$showSelectHighli,
      _ref$showSelectColumn = _ref.showSelectColumn,
      showSelectColumn = _ref$showSelectColumn === void 0 ? true : _ref$showSelectColumn,
      _ref$selectColumnSort = _ref.selectColumnSortable,
      selectColumnSortable = _ref$selectColumnSort === void 0 ? true : _ref$selectColumnSort,
      _ref$selectColumnFilt = _ref.selectColumnFilterable,
      selectColumnFilterable = _ref$selectColumnFilt === void 0 ? false : _ref$selectColumnFilt,
      _ref$selectionColumnD = _ref.selectionColumnDefinition,
      selectionColumnDefinition = _ref$selectionColumnD === void 0 ? {} : _ref$selectionColumnD,
      _ref$filterBarOptions = _ref.filterBarOptions,
      filterBarOptions = _ref$filterBarOptions === void 0 ? undefined : _ref$filterBarOptions,
      _ref$renderToolbar = _ref.renderToolbar,
      renderToolbar = _ref$renderToolbar === void 0 ? undefined : _ref$renderToolbar,
      _ref$toolbarDelayClos = _ref.toolbarDelayClose,
      toolbarDelayClose = _ref$toolbarDelayClos === void 0 ? 400 : _ref$toolbarDelayClos,
      _ref$renderFilterTool = _ref.renderFilterToolbar,
      renderFilterToolbar = _ref$renderFilterTool === void 0 ? undefined : _ref$renderFilterTool,
      _ref$multiSelectCompo = _ref.multiSelectComponent,
      multiSelectComponent = _ref$multiSelectCompo === void 0 ? undefined : _ref$multiSelectCompo,
      noResultsRender = _ref.noResultsRender,
      noResultsPlaceholder = _ref.noResultsPlaceholder,
      _ref$fluidHeight = _ref.fluidHeight,
      fluidHeight = _ref$fluidHeight === void 0 ? false : _ref$fluidHeight,
      _ref$customHandlers = _ref.customHandlers,
      customHandlers = _ref$customHandlers === void 0 ? {} : _ref$customHandlers,
      _ref$groupedBy = _ref.groupedBy,
      groupedBy = _ref$groupedBy === void 0 ? undefined : _ref$groupedBy,
      _ref$onDefaultFilters = _ref.onDefaultFiltersLoad,
      onDefaultFiltersLoad = _ref$onDefaultFilters === void 0 ? function () {
    return null;
  } : _ref$onDefaultFilters,
      _ref$onReorder = _ref.onReorder,
      onReorder = _ref$onReorder === void 0 ? function () {
    return null;
  } : _ref$onReorder,
      _ref$onMoveRowEnd = _ref.onMoveRowEnd,
      onMoveRowEnd = _ref$onMoveRowEnd === void 0 ? function () {
    return null;
  } : _ref$onMoveRowEnd,
      _ref$onMoveRowStart = _ref.onMoveRowStart,
      onMoveRowStart = _ref$onMoveRowStart === void 0 ? function () {
    return null;
  } : _ref$onMoveRowStart,
      _ref$onMoveColumnOver = _ref.onMoveColumnOver,
      onMoveColumnOver = _ref$onMoveColumnOver === void 0 ? function () {
    return null;
  } : _ref$onMoveColumnOver,
      _ref$onMoveColumnStar = _ref.onMoveColumnStart,
      onMoveColumnStart = _ref$onMoveColumnStar === void 0 ? function () {
    return null;
  } : _ref$onMoveColumnStar,
      _ref$onMoveColumnEnd = _ref.onMoveColumnEnd,
      onMoveColumnEnd = _ref$onMoveColumnEnd === void 0 ? function () {
    return null;
  } : _ref$onMoveColumnEnd,
      _ref$onColumnResize = _ref.onColumnResize,
      onColumnResize = _ref$onColumnResize === void 0 ? function () {
    return null;
  } : _ref$onColumnResize,
      _ref$onExpandChange = _ref.onExpandChange,
      onExpandChange = _ref$onExpandChange === void 0 ? function () {
    return null;
  } : _ref$onExpandChange,
      _ref$onToggleExpand = _ref.onToggleExpand,
      onToggleExpand = _ref$onToggleExpand === void 0 ? function () {
    return null;
  } : _ref$onToggleExpand,
      _ref$onExpandRow = _ref.onExpandRow,
      onExpandRow = _ref$onExpandRow === void 0 ? function () {
    return null;
  } : _ref$onExpandRow,
      _ref$onFilter = _ref.onFilter,
      onFilter = _ref$onFilter === void 0 ? function () {
    return null;
  } : _ref$onFilter,
      _ref$onSort = _ref.onSort,
      onSort = _ref$onSort === void 0 ? function () {
    return null;
  } : _ref$onSort,
      _ref$onColumnRowEdite = _ref.onColumnRowEdited,
      onColumnRowEdited = _ref$onColumnRowEdite === void 0 ? function () {
    return null;
  } : _ref$onColumnRowEdite,
      _ref$onColumnRowEdit = _ref.onColumnRowEdit,
      onColumnRowEdit = _ref$onColumnRowEdit === void 0 ? function () {
    return null;
  } : _ref$onColumnRowEdit,
      _ref$onSelectRow = _ref.onSelectRow,
      onSelectRow = _ref$onSelectRow === void 0 ? function () {
    return null;
  } : _ref$onSelectRow,
      _ref$onSelectAll = _ref.onSelectAll,
      onSelectAll = _ref$onSelectAll === void 0 ? function () {
    return null;
  } : _ref$onSelectAll,
      _ref$onInfiniteScroll = _ref.onInfiniteScrolling,
      onInfiniteScrolling = _ref$onInfiniteScroll === void 0 ? function () {
    return null;
  } : _ref$onInfiniteScroll,
      _ref$onFilterMenuClos = _ref.onFilterMenuClose,
      onFilterMenuClose = _ref$onFilterMenuClos === void 0 ? function () {
    return null;
  } : _ref$onFilterMenuClos,
      _ref$onFilterMenuOpen = _ref.onFilterMenuOpen,
      onFilterMenuOpen = _ref$onFilterMenuOpen === void 0 ? function () {
    return null;
  } : _ref$onFilterMenuOpen,
      _ref$getData = _ref.getData,
      getData = _ref$getData === void 0 ? undefined : _ref$getData,
      _ref$serverSideData = _ref.serverSideData,
      serverSideData = _ref$serverSideData === void 0 ? false : _ref$serverSideData,
      _ref$isDataSorted = _ref.isDataSorted,
      isDataSorted = _ref$isDataSorted === void 0 ? false : _ref$isDataSorted,
      _ref$isDataFiltered = _ref.isDataFiltered,
      isDataFiltered = _ref$isDataFiltered === void 0 ? false : _ref$isDataFiltered,
      _ref$virtualized = _ref.virtualized,
      virtualized = _ref$virtualized === void 0 ? true : _ref$virtualized,
      _ref$numRowsVisible = _ref.numRowsVisible,
      numRowsVisible = _ref$numRowsVisible === void 0 ? undefined : _ref$numRowsVisible,
      _ref$isColumnEditable = _ref.isColumnEditable,
      isColumnEditable = _ref$isColumnEditable === void 0 ? function (column) {
    return column.editable;
  } : _ref$isColumnEditable,
      _ref$groupedRows = _ref.groupedRows,
      groupedRows = _ref$groupedRows === void 0 ? false : _ref$groupedRows,
      _ref$groupedRowsRende = _ref.groupedRowsRenderHeader,
      groupedRowsRenderHeader = _ref$groupedRowsRende === void 0 ? undefined : _ref$groupedRowsRende,
      _ref$renderExpandedDe = _ref.renderExpandedDetails,
      renderExpandedDetails = _ref$renderExpandedDe === void 0 ? function () {
    return null;
  } : _ref$renderExpandedDe,
      detailColumns = _ref.detailColumns,
      _ref$expandable = _ref.expandable,
      expandable = _ref$expandable === void 0 ? false : _ref$expandable,
      _ref$getChildrenRows = _ref.getChildrenRows,
      getChildrenRows = _ref$getChildrenRows === void 0 ? function (row) {
    return row.children;
  } : _ref$getChildrenRows,
      _ref$expandableSubrow = _ref.expandableSubrowsVisible,
      expandableSubrowsVisible = _ref$expandableSubrow === void 0 ? 7 : _ref$expandableSubrow,
      _ref$renderRowDetails = _ref.renderRowDetails,
      renderRowDetails = _ref$renderRowDetails === void 0 ? function () {
    return null;
  } : _ref$renderRowDetails,
      _ref$getExpandedRowSi = _ref.getExpandedRowSize,
      getExpandedRowSize = _ref$getExpandedRowSi === void 0 ? undefined : _ref$getExpandedRowSi,
      getExpandedRowMinSize = _ref.getExpandedRowMinSize,
      _ref$rowSize = _ref.rowSize,
      rowSize = _ref$rowSize === void 0 ? RowSizesOptions.normal : _ref$rowSize,
      _ref$subRowSize = _ref.subRowSize,
      subRowSize = _ref$subRowSize === void 0 ? RowSizesOptions.normal : _ref$subRowSize,
      _ref$bindColumnsSizeT = _ref.bindColumnsSizeTo,
      bindColumnsSizeTo = _ref$bindColumnsSizeT === void 0 ? undefined : _ref$bindColumnsSizeT,
      _ref$bindRowSizeTo = _ref.bindRowSizeTo,
      bindRowSizeTo = _ref$bindRowSizeTo === void 0 ? undefined : _ref$bindRowSizeTo,
      onToggleShowAllRows = _ref.onToggleShowAllRows,
      expandedRows = _ref.expandedRows,
      _ref$autoHeight = _ref.autoHeight,
      autoHeight = _ref$autoHeight === void 0 ? false : _ref$autoHeight,
      noColumnsPlaceholder = _ref.noColumnsPlaceholder,
      _ref$plugins = _ref.plugins,
      plugins = _ref$plugins === void 0 ? [] : _ref$plugins,
      _ref$normalizeDataKey = _ref.normalizeDataKeys,
      normalizeDataKeys = _ref$normalizeDataKey === void 0 ? false : _ref$normalizeDataKey;
  return /*#__PURE__*/React.createElement(TooltipTextProvider, null, /*#__PURE__*/React.createElement(DataGridImpl, {
    aggregations: aggregations,
    autoHeight: autoHeight && !fluidHeight,
    autoScrollToId: autoScrollToId,
    bindColumnsSizeTo: bindColumnsSizeTo,
    bindRowSizeTo: bindRowSizeTo,
    className: className,
    columns: columns,
    containerProps: containerProps,
    customHandlers: customHandlers,
    detailColumns: detailColumns,
    dragAndDropColumns: dragAndDropColumns,
    dragAndDropRows: dragAndDropRows,
    editable: editable,
    expandable: expandable,
    expandableSubrowsVisible: expandableSubrowsVisible,
    expandedRows: expandedRows,
    filterBarOptions: filterBarOptions,
    filters: filters,
    fixedHeader: fixedHeader,
    fluidHeight: fluidHeight,
    getChildrenRows: getChildrenRows,
    getData: getData,
    getExpandedRowMinSize: getExpandedRowMinSize,
    getExpandedRowSize: getExpandedRowSize,
    groupedBy: groupedBy,
    groupedRows: groupedRows,
    groupedRowsRenderHeader: groupedRowsRenderHeader,
    groupingColumn: groupingColumn,
    height: height,
    infiniteScrolling: infiniteScrolling,
    instanceRef: instanceRef,
    isColumnEditable: isColumnEditable,
    isDataFiltered: isDataFiltered,
    isDataSorted: isDataSorted,
    maxPerPage: maxPerPage,
    minColumnWidth: minColumnWidth,
    minPerPage: minPerPage,
    multiSelectComponent: multiSelectComponent,
    multiSelectFilterLabel: multiSelectFilterLabel,
    multiSelectFilterLabels: multiSelectFilterLabels,
    multiSelectFilterOptions: multiSelectFilterOptions,
    noColumnsPlaceholder: noColumnsPlaceholder,
    noResultsPlaceholder: noResultsPlaceholder,
    noResultsRender: noResultsRender,
    normalizeDataKeys: normalizeDataKeys,
    numRowsVisible: numRowsVisible // if defined, fluidHeight is disabled
    ,
    onAddFilter: onAddFilter,
    onColumnResize: onColumnResize,
    onColumnRowEdit: onColumnRowEdit,
    onColumnRowEdited: onColumnRowEdited,
    onExpandRow: onExpandRow,
    onExpandChange: onExpandChange,
    onFilter: onFilter,
    onFiltersChange: onFiltersChange,
    onFilterMenuClose: onFilterMenuClose,
    onFilterMenuOpen: onFilterMenuOpen,
    onDefaultFiltersLoad: onDefaultFiltersLoad,
    onInfiniteScrolling: onInfiniteScrolling,
    onMoveColumnEnd: onMoveColumnEnd,
    onMoveColumnOver: onMoveColumnOver,
    onMoveColumnStart: onMoveColumnStart,
    onMoveRowEnd: onMoveRowEnd,
    onMoveRowStart: onMoveRowStart,
    onPageChange: onPageChange,
    onPerPageChange: onPerPageChange,
    onRemoveFilter: onRemoveFilter,
    onReorder: onReorder,
    onSelectAll: onSelectAll,
    onSelectRow: onSelectRow,
    onSort: onSort,
    onToggleExpand: onToggleExpand,
    onToggleShowAllRows: onToggleShowAllRows,
    overscanCount: overscanCount,
    paginated: paginated,
    pagination: pagination,
    paginationStep: paginationStep,
    plugins: plugins,
    renderExpandedDetails: renderExpandedDetails,
    renderFilterToolbar: renderFilterToolbar,
    renderRowDetails: renderRowDetails,
    renderToolbar: renderToolbar,
    resizeableColumns: resizeableColumns,
    rowKey: rowKey,
    rows: rows,
    rowSize: rowSize,
    searchFilters: searchFilters,
    selectable: selectable,
    selectAll: selectAll,
    selectColumnFilterable: selectColumnFilterable,
    selectColumnSortable: selectColumnSortable,
    selectedRows: selectedRows,
    selectionColumnDefinition: selectionColumnDefinition,
    serverSideData: serverSideData,
    showFilterBar: showFilterBar,
    showHeader: showHeader,
    showRowsLoader: showRowsLoader,
    showSelectColumn: showSelectColumn,
    showSelectHighlight: showSelectHighlight,
    sortable: sortable,
    sortEmptyLast: sortEmptyLast,
    sortingColumns: sortingColumns,
    subrowSize: subRowSize,
    toolbarDelayClose: toolbarDelayClose,
    useTreeData: useTreeData,
    virtualized: virtualized,
    visibleColumns: visibleColumns,
    wrapText: wrapText
  }));
};

var props = {
  /** ref to the instance of the datagrid, handle it imperatively */
  instanceRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]).description('ref to the instance of the datagrid, handle it imperatively'),

  /** class for data grid wrapper */
  className: PropTypes.string.description('class for data grid wrapper'),

  /** inject props to datagrid wrapper */
  containerProps: PropTypes.object.description('inject props to datagrid wrapper'),

  /** FilterBar props passed down to FilterBar */
  filterBarOptions: PropTypes.shape({
    minWidth: PropTypes.number,
    maxWidth: PropTypes.number
  }).description('FilterBar props passed down to FilterBar'),

  /** datagrid columns */
  columns: PropTypes.arrayOf(PropTypes.shape({
    /** Column property as an identifier */
    property: PropTypes.string.isRequired,

    /** Label in the header */
    label: PropTypes.string,

    /** Defines the width of the column, can be a string with percentages ("50%"), if not defined the width is flexible */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Min width for this column. NOTE: Has prevalence over the general minColumnWidth */
    minWidth: PropTypes.number,

    /** Function returning a custom editor for that cell ({ value, onValue, rowData }) => Element */
    customEditor: PropTypes.func,

    /** Function returning an element to render in the cell ({ value, customHandlers, metaData: { rowData } }) => Element */
    customRenderer: PropTypes.func,

    /** Activates 'searchable' feature for this column */
    searchable: PropTypes.bool,

    /** Activates 'sortable' feature for this column */
    sortable: PropTypes.bool,

    /** Activates 'resizable' feature for this column */
    resizable: PropTypes.bool,

    /** Activates 'editable' feature for this column */
    editable: PropTypes.bool,

    /** Whether this column is visible or not */
    visible: PropTypes.bool
  })).description('datagrid columns'),

  /** datagrid rows */
  rows: PropTypes.arrayOf(PropTypes.object).description('datagrid rows'),

  /** key for each row */
  rowKey: PropTypes.string.description('key for each row'),

  /** toggle infinite scroll loading behavior */
  infiniteScrolling: PropTypes.bool.description('toggle infinite scroll loading behavior'),

  /** Activates 'editable' feature on the DataGrid NOTE: needs to be activated in the column definition as well */
  overscanCount: PropTypes.number.description("Activates 'editable' feature on the DataGrid NOTE: needs to be activated in the column definition as well"),

  /** turn datagrid to editable mode */
  editable: PropTypes.bool.description('turn datagrid to editable mode'),

  /** Activates 'sortable' feature on the GataGrid NOTE: needs to be activated in the column definition as well */
  sortable: PropTypes.bool.description("Activates 'sortable' feature on the GataGrid NOTE: needs to be activated in the column definition as well"),

  /** Put empty values always last on the column after sorting */
  sortEmptyLast: PropTypes.bool.description('Put empty values always last on the column after sorting'),

  /** Activates 'pagination' feature on the datagrid NOTE: needs to be activated in the column definition as well */
  paginated: PropTypes.bool.description("Activates 'pagination' feature on the datagrid NOTE: needs to be activated in the column definition as well"),

  /** Pagination step for clicking the next pages */
  paginationStep: PropTypes.number.description('Pagination step for clicking the next pages'),

  /** Activates 'drag and drop rows' feature on the datagrid NOTE: needs to be activated in the column definition as well */
  dragAndDropRows: PropTypes.bool.description("Activates 'drag and drop rows' feature on the datagrid NOTE: needs to be activated in the column definition as well"),

  /** Activates 'selection' feature on the datagrid NOTE: needs to be activated in the column definition as well */
  selectable: PropTypes.bool.description("Activates 'selection' feature on the datagrid NOTE: needs to be activated in the column definition as well"),

  /** Activates 'resize' feature on the datagrid NOTE: needs to be activated in the column definition as well */
  resizeableColumns: PropTypes.bool.description("Activates 'resize' feature on the datagrid NOTE: needs to be activated in the column definition as well"),

  /** Placeholder rendered when no rows are visible */
  noResultsPlaceholder: PropTypes.oneOf([PropTypes.string, PropTypes.element]).description('Placeholder rendered when no rows are visible'),

  /** Activates 'filtering' feature on the datagrid NOTE: needs to be activated in the column definition as well */
  searchFilters: PropTypes.bool.description("activates 'filtering' feature on the datagrid NOTE: needs to be activated in the column definition as well"),

  /** Activates 'drag and drop columns' feature on the datagrid NOTE: needs to be activated in the column definition as well */
  dragAndDropColumns: PropTypes.bool.description("Activates 'drag and drop columns' feature on the datagrid NOTE: needs to be activated in the column definition as well"),

  /** Activates 'grouping and tree data' feature on the datagrid NOTE: needs to be activated in the column definition as well */
  useTreeData: PropTypes.bool.description("activates 'grouping and tree data' feature on the datagrid NOTE: needs to be activated in the column definition as well"),

  /** AutoScroll to row ID */
  autoScrollToId: PropTypes.any.description('AutoScroll to row ID'),

  /** Whether all rows are selected or not */
  selectAll: PropTypes.bool.description('Whether all rows are selected or not'),

  /** Defines the selected rows */
  selectedRows: PropTypes.arrayOf(PropTypes.object).description(' Defines the selected rows'),

  /** Filters to be applied to the grid */
  filters: PropTypes.arrayOf(PropTypes.object).description('Filters to be applied to the grid'),
  // todo: define params for handlers

  /** Handler when user expands a row */
  onExpandRow: PropTypes.func.description('Handler when user expands a row'),

  /** Handler when user expands a row with full expand state */
  onExpandChange: PropTypes.func.description('Handler when user expands a row with full expand state'),

  /** Handler when user expands a row (old API) */
  onToggleExpand: PropTypes.func.description('Handler when user expands a row (old API)'),

  /** Handler when user adds a filter */
  onAddFilter: PropTypes.func.description('Handler when user adds a filter'),

  /** Handler when user removes a filter */
  onRemoveFilter: PropTypes.func.description('Handler when user removes a filter'),

  /** Handler when the filters state has changed */
  onFiltersChange: PropTypes.func.description('Handler when the filters state has changed '),

  /** Handler when the default filters load. Returns the rows rendered */
  onDefaultFiltersLoad: PropTypes.func.description('Handler when the default filters load. Returns the rows rendered'),

  /** Handler when column move is over another column */
  onMoveColumnOver: PropTypes.func.description('Handler when column move is over another column'),

  /** Handler when column move starts */
  onMoveColumnStart: PropTypes.func.description(' Handler when column move starts'),

  /** Handler when column move ends */
  onMoveColumnEnd: PropTypes.func.description('Handler when column move ends'),

  /** Whether to show the filter bar or not */
  showFilterBar: PropTypes.bool.description('Whether to show the filter bar or not'),

  /** Custom option for the header with multi select */
  multiSelectFilterOptions: PropTypes.arrayOf(PropTypes.object).description('Custom option for the header with multi select'),

  /** Label to the header column for multi select */
  multiSelectFilterLabel: PropTypes.string.description('Label to the header column for multi select'),

  /** Labels for multi selects */
  multiSelectFilterLabels: PropTypes.arrayOf(PropTypes.string).description('Labels for multi selects'),

  /** unstable */
  aggregations: PropTypes.object.description('').deprecated(''),

  /** unstable */

  /** Column which rows would be grouped by */
  groupingColumn: PropTypes.string.description('Column which rows would be grouped by').deprecated(''),

  /** group by */
  groupedBy: PropTypes.string.description('group by'),

  /** Defines the sorting state */
  sortingColumns: PropTypes.objectOf(PropTypes.shape({
    // eslint-disable-next-line react/no-unused-prop-types
    direction: PropTypes.oneOf(['asc', 'desc']),
    // eslint-disable-next-line react/no-unused-prop-types
    position: PropTypes.number
  })).description('Defines the sorting state'),

  /** Visible columns property */
  visibleColumns: PropTypes.arrayOf(PropTypes.string).description('Visible columns property'),

  /** Pagination: Minimum number of rows per page */
  minPerPage: PropTypes.string.description('Pagination: Minimum number of rows per page'),

  /** Pagination: Maximum number of rows per page */
  maxPerPage: PropTypes.string.description('Pagination: Maximum number of rows per page'),

  /** Pagination: Handler when user changes the amount of rows per page */
  onPerPageChange: PropTypes.string.description('Pagination: Handler when user changes the amount of rows per page'),

  /** Pagination: Handler when user changes the page */
  onPageChange: PropTypes.string.description('Pagination: Handler when user changes the page'),

  /** Pagination state */
  pagination: PropTypes.shape({
    // eslint-disable-next-line react/no-unused-prop-types
    page: PropTypes.number,
    // eslint-disable-next-line react/no-unused-prop-types
    perPage: PropTypes.number
  }).description('pagination state'),

  /** Whether to show the header or not */
  showHeader: PropTypes.bool.description('Whether to show the header or not'),

  /** Whether to header is fixed or not */
  fixedHeader: PropTypes.bool.description('Whether to header is fixed or not'),

  /** Defines the height of the DataGrid */
  height: PropTypes.number.description('Defines the height of the DataGrid'),

  /** General min column width for all the columns */
  minColumnWidth: PropTypes.number.description('General min column width for all the columns '),

  /** Whether to show a loader instead of the rows or not */
  showRowsLoader: PropTypes.bool.description('Whether to show a loader instead of the rows or not'),

  /** When a user selects a row, that row get highlighted */
  showSelectHighlight: PropTypes.bool.description('When a user selects a row, that row get highlighted'),

  /** Whether to show the select column when the selection feature is active */
  showSelectColumn: PropTypes.bool.description('Whether to show the select column when the selection feature is active'),

  /** Activates sortable feature to selection column */
  selectColumnSortable: PropTypes.bool.description('activates sortable feature to selection column'),

  /** Activates filterable feature to selection column */
  selectColumnFilterable: PropTypes.bool.description('Activates filterable feature to selection column'),

  /** Define the definition for the selection column */
  selectionColumnDefinition: PropTypes.object.description('Define the definition for the selection column'),

  /** Function that returns a toolbar to show when the user hovers the row */
  renderToolbar: PropTypes.func.description('Function that returns a toolbar to show when the user hovers the row'),

  /** Timeout to close the toolbar */
  toolbarDelayClose: PropTypes.number.description(' Timeout to close the toolbar'),

  /** Function that returns a toolbar in the FilterBar component */
  renderFilterToolbar: PropTypes.func.description('Function that returns a toolbar in the FilterBar component'),

  /** Custom component for the selection */
  multiSelectComponent: PropTypes.element.description('Custom component for the selection'),

  /** Normalize the keys of the data received and the columns */
  normalizeDataKeys: PropTypes.bool.description('Normalize the keys of the data received and the columns'),

  /** Function that returns an Element when there are no rows */
  noResultsRender: PropTypes.func.description('Function that returns an Element when there are no rows'),

  /** The height of the DataGrid will expand to its container */
  fluidHeight: PropTypes.bool.description('The height of the DataGrid will expand to its container'),

  /** @deprecated */
  customHandlers: PropTypes.object.description('').deprecated(''),

  /** Handler when user closes the filter menu */
  onFilterMenuClose: PropTypes.func.description('Handler when user closes the filter menu'),

  /** Handler when user opens the filter menu */
  onFilterMenuOpen: PropTypes.func.description('Handler when user opens the filter menu'),

  /** Handler when user drags a row */
  onReorder: PropTypes.func.description('handler when user drags a row '),

  /** Handler when user stops dragging a row */
  onMoveRowEnd: PropTypes.func.description('Handler when user stops dragging a row '),

  /** Handler when user starts dragging a row */
  onMoveRowStart: PropTypes.func.description('Handler when user starts dragging a row'),

  /** Handler when user has resized a column */
  onColumnResize: PropTypes.func.description('Handler when user has resized a column'),

  /** Handler when user filters by a column */
  onFilter: PropTypes.func.description('Handler when user filters by a column'),

  /** Handler when user sorts by a column */
  onSort: PropTypes.func.description('Handler when user sorts by a column '),

  /** Handler when user has edited a cell row */
  onColumnRowEdited: PropTypes.func.description('Handler when user has edited a cell row'),

  /** Handler when user activates the cell row editing functionality */
  onColumnRowEdit: PropTypes.func.description(' Handler when user activates the cell row editing functionality'),

  /** Handler when user selects a row */
  onSelectRow: PropTypes.func.description('Handler when user selects a row'),

  /** Handler when user checks the selection header controller */
  onSelectAll: PropTypes.func.description('Handler when user checks the selection header controller'),

  /** Handler to get more data when infinite scroll is activated */
  getData: PropTypes.func.description('Handler to get more data when infinite scroll is activated'),

  /** Handler to get more data when infinite scroll is activated without side-effect */
  onInfiniteScrolling: PropTypes.func.description('Handler to get more data when infinite scroll is activated without side-effect'),

  /** Flag to override empty sort when data is from server */
  serverSideData: PropTypes.bool.description('Flag to override empty sort when data is from server'),

  /** Flag to force virtualization. Not used */
  virtualized: PropTypes.bool.description('Flag to force virtualization. Not used'),

  /** Number of rows visible. Not used */
  numRowsVisible: PropTypes.oneOf([PropTypes.number, 'all']).description('Number of rows visible. Not used'),

  /** Callback to check if column is editable */
  isColumnEditable: PropTypes.func.description('Callback to check if column is editable'),

  /** Flag for groupedRows */
  groupedRows: PropTypes.bool.description('Flag for groupedRows'),

  /** Header for grouped rows */
  groupedRowsRenderHeader: PropTypes.oneOf([PropTypes.func, PropTypes.element]).description('Header for grouped rows'),

  /** Once activated will disable the internal logic for sorting */
  isDataSorted: PropTypes.bool.description('Once activated will disable the internal logic for sorting'),

  /** Once activated will disable the internal logic for filtering */
  isDataFiltered: PropTypes.bool.description('Once activated will disable the internal logic for filtering'),

  /** Change row size */
  rowSize: PropTypes.oneOf(RowSizesOptionsArr).description('Change row size'),

  /** Whether to wrap the text of the data grid or not */
  wrapText: PropTypes.bool.description('Whether to wrap the text of the data grid or not'),

  /** Element to render expanded details */
  renderExpandedDetails: PropTypes.oneOf([PropTypes.func, PropTypes.element]).description('Element to render expanded details'),

  /** Columns to render on the details of an expanded row */
  detailColumns: PropTypes.arrayOf(PropTypes.object).description('Columns to render on the details of an expanded row'),

  /** Flag to enable the expandable feature */
  expandable: PropTypes.bool.description('Flag to enable the expandable feature '),

  /** Callback to get the row children */
  getChildrenRows: PropTypes.func.description('Callback to get the row children'),

  /** Number of rows visible on the details of an expanded row */
  expandableSubrowsVisible: PropTypes.number.description('Number of rows visible on the details of an expanded row'),

  /** Element to render inside expanded row */
  renderRowDetails: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).description('Element to render inside expanded row'),

  /** Callback to get the expanded row size */
  getExpandedRowSize: PropTypes.func.description('Callback to get the expanded row size'),

  /** Callback to get the expanded row minimum size */
  getExpandedRowMinSize: PropTypes.func.description('Callback to get the expanded row minimum size'),

  /** Change expanded/details rows size */
  subRowSize: PropTypes.oneOf(RowSizesOptionsArr).description('Change expanded/details rows size'),

  /** Bind the column size to another grid instance */
  bindColumnsSizeTo: PropTypes.string.description('Bind the column size to another grid instance'),

  /** Bind the row size to another grid instance */
  bindRowSizeTo: PropTypes.string.description('Bind the row size to another grid instance'),

  /** Handler when toggle show all is clicked  */
  onToggleShowAllRows: PropTypes.func.description('Handler when toggle show all is clicked'),

  /** Expanded row state */
  expandedRows: PropTypes.object.description('Expanded row state'),

  /** Flag to enable autoheight */
  autoHeight: PropTypes.bool.description('Flag to enable autoheight'),

  /** Placeholder rendered when no columns are visible */
  noColumnsPlaceholder: PropTypes.oneOf([PropTypes.string, PropTypes.element]).description('Placeholder rendered when no columns are visible'),

  /** Plugin additional array */
  plugins: PropTypes.arrayOf(PropTypes.any).description('Plugin additional array')
};
DSDataGrids.propTypes = props;
var DSDataGridsWithSchema = describe(DSDataGrids);
DSDataGridsWithSchema.propTypes = props;

export default DSDataGrids;
export { DSDataGridsWithSchema };
//# sourceMappingURL=DSDataGrid.js.map
